export const ENTITY_NAME = 'Travelers_'